import React from 'react'
import './TableLegacy.scss'

interface ITableLegacy {
	columns: any[]
	data: any
}

const TableLegacy = ({ columns, data }: ITableLegacy) => {
	return (
		<table className="table table-striped mt-3">
			<thead>
				<tr>
					{columns.map((item, key) => {
						return (
							<th key={key} scope="col">
								{item}
							</th>
						)
					})}
				</tr>
			</thead>
			<tbody>{data}</tbody>
		</table>
	)
}

export default TableLegacy
